import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

class Ims extends Component {
    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'ims'}
            title={ t('support.procedure.P1.title') }
            exportTitle={ t('support.procedure.P1.exportTitle') }
            exportFileName={'ims.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (Ims);
